import { ApiResponse } from '@models/common/api';
import { ISubscribeRequest, IUnsubscribeRequest, IUpsertSubscriberRequest } from '@models/notification/request';
import { ISubscribeResponse } from '@models/notification/response';

import { get, post } from './methods';

const BASE_ENDPOINT = 'subscribers';

const notificationAPI = {
  upsertSubscriber: async (subscriber: IUpsertSubscriberRequest) => {
    const response = await post<ApiResponse<ISubscribeResponse>>(BASE_ENDPOINT, subscriber);
    return response.data;
  },

  subscribe: async (subscribeData: ISubscribeRequest) => {
    const response = await post<ApiResponse<ISubscribeResponse>>(`${BASE_ENDPOINT}/subscribe/push`, subscribeData);
    return response.data;
  },

  unsubscribeEmailChannel: async (unsubscribeData: IUnsubscribeRequest) => {
    const response = await get<ApiResponse<ISubscribeResponse>>(
      `${BASE_ENDPOINT}/preferences/${unsubscribeData.subscriberId}`,
      {
        params: { workflowId: unsubscribeData.workflowId },
      },
    );
    return response.data;
  },
};
export default notificationAPI;
